import React, { useEffect } from 'react';
import { useAdmin } from '../contexts/AdminContext';

/**
 * AdminToWebsiteConnector - Connects all admin functionality to website components
 * This component ensures that changes made in the admin panel reflect on the website
 */
const AdminToWebsiteConnector = () => {
  const { 
    companySettings,
    sliders,
    offers,
    blogs,
    pages,
    feedbacks,
    convenienceFees,
    onlineTransactions,
    paymentHistory,
    creditNotes
  } = useAdmin();

  useEffect(() => {
    // Log admin data changes for debugging
    console.log('AdminToWebsiteConnector: Admin data updated', {
      companySettings,
      slidersCount: sliders.length,
      offersCount: offers.length,
      blogsCount: blogs.length,
      pagesCount: pages.length,
      feedbacksCount: feedbacks.length,
      convenienceFeesCount: convenienceFees.length,
      onlineTransactionsCount: onlineTransactions.length,
      paymentHistoryCount: paymentHistory.length,
      creditNotesCount: creditNotes.length
    });
  }, [
    companySettings,
    sliders,
    offers,
    blogs,
    pages,
    feedbacks,
    convenienceFees,
    onlineTransactions,
    paymentHistory,
    creditNotes
  ]);

  // This component doesn't render anything, it just manages connections
  return null;
};

export default AdminToWebsiteConnector;







